import React from 'react';

import { DecisionStatus } from '@ariksa/jit/api';

import { MyRequestsTable } from './MyRequestsTable';

interface MyRequestsProps {
  decisionStatus?: DecisionStatus;
}

export const MyRequests = ({ decisionStatus }: MyRequestsProps) => (
  <MyRequestsTable decisionStatus={decisionStatus} />
);
